import dayjs from 'dayjs';

export class BasketOrderRefunded {
  public id!: number;
  public billDate?: dayjs.Dayjs;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.billDate = data.billDate ? dayjs(data.billDate) : undefined;
  }
}
